import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/products/')({
  component: ProductsPage,
})

function ProductsPage(): JSX.Element {
  return <div>Productos — placeholder</div>
}
